import { BlockNameEnum } from '@/enum/BlockNameEnum';

const STRAPI_COMPONENT_KEY = '__component' as const;

type StrapiBlock = {
  id?: number;
  cases?: Array<{ id?: number; clientPage?: unknown }>;
} & Partial<Record<typeof STRAPI_COMPONENT_KEY, string>>;

type StrapiContent = {
  blocks?: StrapiBlock[];
};

function buildClientPageMap(enrichmentBlocks: StrapiBlock[] | undefined, blockId: number | undefined) {
  const enrichmentBlock = enrichmentBlocks?.find(
    (block) =>
      block[STRAPI_COMPONENT_KEY] === BlockNameEnum.CUSTOMER_CASES && block.id === blockId,
  );

  return new Map(
    (enrichmentBlock?.cases ?? [])
      .filter((caseItem): caseItem is { id: number; clientPage?: unknown } => typeof caseItem.id === 'number')
      .map((caseItem) => [caseItem.id, caseItem.clientPage ?? null]),
  );
}

export function mergeCustomerCaseClientPages<T extends StrapiContent>(
  mainContent: T | null | undefined,
  enrichmentContent: StrapiContent | null | undefined,
): T {
  if (!mainContent?.blocks?.length) {
    return mainContent as T;
  }

  const enrichmentBlocks = enrichmentContent?.blocks;

  return {
    ...mainContent,
    blocks: mainContent.blocks.map((block) => {
      if (block[STRAPI_COMPONENT_KEY] !== BlockNameEnum.CUSTOMER_CASES || !block.cases?.length) {
        return block;
      }

      const clientPageByCaseId = buildClientPageMap(enrichmentBlocks, block.id);

      return {
        ...block,
        cases: block.cases.map((caseItem) => ({
          ...caseItem,
          clientPage: clientPageByCaseId.get(caseItem.id ?? -1) ?? null,
        })),
      };
    }),
  };
}
